import React, { useState, useEffect, useCallback } from "react";

import { useNavigate, Link, useOutletContext } from "react-router-dom";

import { Helmet } from "react-helmet";
import { BiReceipt, BiTask } from 'react-icons/bi'
import { HiOutlineDocumentSearch, HiOutlineCurrencyRupee } from 'react-icons/hi'
import {FiUpload} from 'react-icons/fi'


export default function Home() {
  const [state, setState] = useState({});
  const navigate = useNavigate();
  const [pstate, setPState] = useOutletContext();

  return (
    <div className="home">
      <Helmet>
        <title>{pstate.company.company}</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>

      <div>
        <div className="row mt-1">
        {pstate.company.doc_directory == 1 &&
          <div className="col-sm-3 col-6 mb-4">
            <div className="rounded p-3 text-center bg-white shadow pointer" onClick={() => navigate("/quick-docs")}>
              <div className="fs-1 text-primary"><HiOutlineDocumentSearch /></div>
              <h3 className="mt-2 fs-5">Quick Docs.</h3>
            </div>
          </div>
}
{pstate.company.task_list == 1 &&
          <div className="col-sm-3 col-6 mb-4">
            <div className="rounded p-3 text-center bg-white shadow pointer" onClick={() => navigate("/assignments")}>
              <div className="fs-1 text-primary"><BiTask /></div>
              <h3 className="mt-2 fs-5">Assignments</h3>
            </div>
          </div>
}
{pstate.company.ledger == 1 &&

          <div className="col-sm-3 col-6 mb-4">
            <div className="rounded p-3 text-center bg-white shadow pointer" onClick={() => navigate("/ledger")}>
              <div className="fs-1 text-primary"><BiReceipt /></div>
              <h3 className="mt-2 fs-5">Ledger</h3>
            </div>
          </div>
}
{pstate.company.online_pay == 1 &&
          <div className="col-sm-3 col-6 mb-4">
            <div className="rounded p-3 text-center bg-white shadow pointer" onClick={() => navigate("/online-payment")}>
              <div className="fs-1 text-primary"><HiOutlineCurrencyRupee /></div>
              <h3 className="mt-2 fs-5">Online Payment</h3>
            </div>
          </div>
}
          <div className="col-sm-3 col-6 mb-4">
            <div className="rounded p-3 text-center bg-white shadow pointer" onClick={() => navigate("/upload-docs")}>
              <div className="fs-1 text-primary"><FiUpload /></div>
              <h3 className="mt-2 fs-5">Upload Documents</h3>
            </div>
          </div>
        </div>

      </div>


    </div>
  );
}
